import { useState } from "react";
import axios from "axios";
import { RefreshCw, Activity } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { API } from "./constants";

const SettingsDiagnosticsTab = ({ lang = "en" }) => {
  const [diagnostics, setDiagnostics] = useState(null);
  const [loading, setLoading] = useState(false);
  const accessCode = localStorage.getItem("access_code") || sessionStorage.getItem("access_code") || "";

  const fetchDiagnostics = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/sync/diagnostics`, {
        headers: { "x-access-code": accessCode },
      });
      setDiagnostics(res.data);
    } catch {
      setDiagnostics(null);
    } finally {
      setLoading(false);
    }
  };

  if (!diagnostics && !loading) {
    return (
      <Card className="bg-card border-border/50">
        <CardContent className="py-8 text-center">
          <p className="text-sm text-muted-foreground mb-4">
            {lang === "ko" ? "시스템 진단을 실행하여 상태를 확인하세요" : lang === "zh" ? "运行系统诊断以检查状态" : "Run diagnostics to check system status"}
          </p>
          <Button onClick={fetchDiagnostics} variant="outline" data-testid="run-diagnostics-btn">
            <Activity className="h-4 w-4 mr-2" />
            {lang === "ko" ? "진단 실행" : lang === "zh" ? "运行诊断" : "Run Diagnostics"}
          </Button>
        </CardContent>
      </Card>
    );
  }

  if (loading) {
    return (
      <Card className="bg-card border-border/50">
        <CardContent className="py-8 text-center">
          <RefreshCw className="h-6 w-6 animate-spin mx-auto mb-2" />
          <p className="text-sm text-muted-foreground">{lang === "ko" ? "진단 중..." : lang === "zh" ? "诊断中..." : "Running diagnostics..."}</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="bg-card border-border/50">
      <CardHeader>
        <CardTitle className="text-lg font-heading flex items-center gap-2">
          <Activity className="h-5 w-5 text-primary" />
          {lang === "ko" ? "시스템 진단" : lang === "zh" ? "系统诊断" : "System Diagnostics"}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <pre className="text-xs bg-muted/30 rounded-lg p-4 overflow-auto max-h-[400px] whitespace-pre-wrap">
          {JSON.stringify(diagnostics, null, 2)}
        </pre>
        <Button onClick={fetchDiagnostics} variant="outline" size="sm" className="mt-4" data-testid="rerun-diagnostics-btn">
          <RefreshCw className="h-3 w-3 mr-1" />
          {lang === "ko" ? "다시 실행" : lang === "zh" ? "重新运行" : "Re-run"}
        </Button>
      </CardContent>
    </Card>
  );
};

export default SettingsDiagnosticsTab;
